var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00272D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_14_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black_14_",
    transform: "translate(-200.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line-1_5_",
    transform: "translate(200.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Facebook_2_",
    className: "st0",
    d: "M26.6,49h-23C2.2,49,1,47.8,1,46.4V3.6C1,2.2,2.2,1,3.6,1h42.7 C47.8,1,49,2.2,49,3.6v42.7c0,1.5-1.2,2.6-2.6,2.6H34.1V30.4h6.2l0.9-7.2h-7.2v-4.6c0-2.1,0.6-3.5,3.6-3.5l3.8,0V8.5 c-0.7-0.1-2.9-0.3-5.6-0.3c-5.5,0-9.3,3.4-9.3,9.6v5.3h-6.3v7.2h6.3V49L26.6,49z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.274cc1a9da0ec13b740291431e9824c1.svg";
export { ForwardRef as ReactComponent };